import {FETCH_LIVE_SCHEDULE} from "../../actions";

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_LIVE_SCHEDULE:
            return action.payload;
        default:
            return state;
    }
};
